import { capitalize } from "@mui/material";
import { sentenceCase } from "../../../../constants";

/** Normalizes "Bill Payment" / "bill-payment" / "BILL_PAYMENT" → "bill_payment". */
const getNormalizedType = (item) => {
  const raw = item?.type ?? item?.txn_type ?? "";
  return String(raw).toLowerCase().trim().replace(/[\s-]+/g, "_");
};

const isBillPayment = (item) => {
  if (getNormalizedType(item) === "bill_payment") return true;
  return Boolean(item?.bill_company || item?.consumer_number_masked || item?.consumer_number);
};

const getInvoiceSuffix = (item) => {
  const invoiceNo =
    item?.invoice_number ?? item?.invoice_no ?? item?.invoice_id ?? "";
  return invoiceNo ? ` • INV #${invoiceNo}` : "";
};


export const getWalletTransactionDescription = (item) => {
  const { account_bank, type, service, account_title, created_at, account_number, txn_type, extra_info, plan, invoice_no } = item;

  
  const customerName = item.customer_name && item.customer_name.length > 20 ? `${item.customer_name.slice(0, 20)}...` : item.customer_name || '';

  let title = '';
  let subtitle = '';

  switch (type) {
    case 'deposit': {
      const bankDetails = `${account_bank} ${account_number ? '*' + account_number : ''}`
      const depositDetail = [invoice_no, bankDetails].filter(Boolean).join(' • ');
      title = account_title || 'Deposit';
      subtitle = `Received${depositDetail ? ' • ' + depositDetail : ''}`;
      break;
    }

    case 'transfer': {
      const bankDetails = `${account_bank} ${account_number ? '*' + account_number : ''}`
      const transferDetail = [invoice_no, bankDetails].filter(Boolean).join(' • ');
      title = account_title || 'Transfer';
      subtitle = `Sent${transferDetail ? ' • ' + transferDetail : ''}`;
      break;
    }

    case 'withdraw': {
      const bankDetails = `${account_bank} ${account_number ? '*' + account_number : ''}`
      const withdrawDetail = [invoice_no, bankDetails].filter(Boolean).join(' • ');
      title = account_title || 'Withdraw';
      subtitle = `Sent${withdrawDetail ? ' • ' + withdrawDetail : ''}`;
      break;
    }

    case 'recharge':
    case 'bundle_recharge': {
      const typeLabel = type === 'bundle_recharge' ? 'Package' : 'Easyload';
      const rechargePart = `${sentenceCase(item.service)} ${item.customer}`.trim();
      title = customerName || rechargePart;
      subtitle = customerName ? `${typeLabel}${rechargePart ? ' • ' + rechargePart : ''}` : typeLabel;
      break;
    }

    case 'bill': {
      const billDetail = `${item.bill_company || ''} ${item.consumer_number || ''}`.trim();
      title = customerName || billDetail || 'Bill payment';
      subtitle = customerName ? `Bill${billDetail ? ' • ' + billDetail : ''}` : 'Bill';
      break;
    }

    case 'voucher_payment': {
      const voucherDetail = `${item.service?.trim() || ''} ${item.customer_phone || ''}`.trim();
      title = customerName || voucherDetail || 'Voucher Payment';
      subtitle = customerName ? `Voucher${voucherDetail ? ' • ' + voucherDetail : ''}` : 'Voucher';
      break;
    }

    case 'fee':
      title = 'Fee';
      subtitle = `Sent ${item.reason ? '• ' + item.reason : ''}`;
      break;

    case 'refund':
      title = 'Refund';
      subtitle = '';
      break;

    case 'order_payment':
      title = `Shop`;
      subtitle = `Purchase${item.order_key ? ' • Order # ' + item.order_key : ''}`;
      break;

    case 'commission':
      const commissionType = txn_type?.toLowerCase() === 'recharge' ? 'Easyload' : txn_type?.toLowerCase() === 'bundle recharge' ? 'Package' : txn_type;
      const dispService = ['voucher', 'bill'].includes(txn_type?.toLowerCase()) ? service : sentenceCase(service);
      title = item.display_tran_name ?? 'Rupin Cashback';
      subtitle = `${commissionType ? commissionType + ' • ' : ''}${dispService || ''} ${extra_info || ''}`.trim();
      break;

    case 'cash_back':
      title = 'Rupin Cashback';
      subtitle = service ?? '';
      break;

    case 'sms_bundle_payment':
      title = 'SMS plan';
      subtitle = `Purchase${plan ? ' • ' + plan : ''}`;
      break;

    default:
      title = item.type || 'Transaction';
      subtitle = item.account_bank ? `${item.account_bank} *${item.account_number ?? ''}` : '';
      break;
  }
  return {
    title: title.trim() !== "" ? title : "-", subtitle: subtitle.trim() !== "" ? subtitle : "-"
  }
};
